import lazyLoading from './lazyLoading'

export default {
  name: 'Fixtures',
  role: 'user',
  meta: {
    icon: 'fa-calendar',
    expanded: false,
    auth: { roles: 'user' }
  },

  children: [
    {
      name: 'Games',
      path: '/Fixtures/season-fixtures',
      role: 'user',
      meta: {
        label: 'Games',
        link: 'Fixtures/season-fixtures.vue',
        auth: true
      },
      component: lazyLoading('Fixtures/season-fixtures')
    },
    {
      name: 'Season Editor',
      path: '/Fixtures/2018_2019_editor',
      role: 'user',
      meta: {
        auth: { roles: ['user', 'admin'], redirect: '/Fixtures/Season/18_19' },
        label: 'Fixture Editor',
        link: 'Fixtures/2018_2019_editor.vue'
      },
      component: lazyLoading('Fixtures/2018_2019_editor')
    },
    {
      name: 'Season',
      path: '/Fixtures/tbl',
      role: 'admin',
      meta: {
        label: 'Season Stats',
        link: 'Fixtures/tbl.vue',
        auth: { roles: 'admin' }
      },
      component: lazyLoading('Fixtures/tbl')
    },

    {
      name: 'Game Data Checklist',
      path: '/season-totals/game-checklist',
      role: 'admin',
      meta: {
        label: 'Game Data Checklist',
        link: 'season-totals/game-checklist.vue',
        auth: { roles: 'admin' }
      },
      component: lazyLoading('season-totals/game-checklist')
    },

    {
      name: 'Game Data Checklist',
      path: '/season-totals/game-checklist-19',
      role: 'user',
      meta: {
        label: 'Game Data Checklist',
        link: 'season-totals/game-checklist-19.vue'
      },
      component: lazyLoading('season-totals/game-checklist-19')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/fixtures.js